<!-- Stat cards -->
<section class="stat-grid">
    @for (s of stats; track s.label) {
        <div class="stat-card">
            <div class="stat-icon" [style.background]="s.color + '1a'" [style.color]="s.color">
                <i [class]="s.icon"></i>
            </div>
            <div class="stat-body">
                <span class="stat-label">{{ s.label }}</span>
                <span class="stat-value">{{ s.value }}</span>
                <span class="stat-delta" [class.down]="!s.up">
                    <i class="pi" [class.pi-arrow-up]="s.up" [class.pi-arrow-down]="!s.up"></i>
                    {{ s.delta }}
                </span>
            </div>
        </div>
    }
</section>

<!-- Charts -->
<section class="chart-grid">
    <div class="chart-card wide">
        <div class="chart-head">
            <h3>Policies vs Claims</h3>
            <span class="chart-sub">Last 7 months</span>
        </div>
        @if (isBrowser) {
            <p-chart type="line" [data]="lineData" [options]="chartOptions" height="300px"></p-chart>
        }
    </div>

    <div class="chart-card">
        <div class="chart-head">
            <h3>Policy Mix</h3>
            <span class="chart-sub">By category</span>
        </div>
        @if (isBrowser) {
            <p-chart type="doughnut" [data]="doughnutData" [options]="doughnutOptions" height="300px"></p-chart>
        }
    </div>

    <div class="chart-card span-2">
        <div class="chart-head">
            <h3>Premium by Product</h3>
            <span class="chart-sub">In ₹ Lakhs</span>
        </div>
        @if (isBrowser) {
            <p-chart type="bar" [data]="barData" [options]="chartOptions" height="300px"></p-chart>
        }
    </div>
</section>
